export default {
	EVENTCERTNUMBER: 'eventcertnumber',
	PRESTINEEVENTCERTNUMBER: 'prestineeventcertnumber',
	SCHOOLNAME: 'schoolname'
}


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/Participants/Constants/fields.js